import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CameraPermissionService, PermissionStatus } from 'src/app/services/camera-permission.service';
import { RecognitionErrors, RecognitionSteps } from '../face-recognition-modal/face-recognition-modal.component';

@Component({
  selector: 'app-camera-selector',
  templateUrl: './camera-selector.component.html',
  styleUrls: ['./camera-selector.component.scss']
})
export class CameraSelectorComponent implements OnInit {
  @Output() cameraSelection: EventEmitter<string> = new EventEmitter();
  @Output() errorType: EventEmitter<RecognitionErrors> = new EventEmitter();
  @Output() closeCameraSelection: EventEmitter<boolean> = new EventEmitter();
  availableCameras: MediaDeviceInfo[] = [];
  camerasChecked: boolean = false;
  selectedCameraId?: string;

  constructor(private cameraPermissionService: CameraPermissionService) { }

  ngOnInit(): void {
    this.loadAvailableCameras();
  }

  async loadAvailableCameras(): Promise<void> {
    try {
      const hasPermission: string = await this.cameraPermissionService.checkCameraPermission();
      if (hasPermission == PermissionStatus.error || hasPermission == PermissionStatus.unsupported) {
        this.errorType.emit(RecognitionErrors.Camera);
        return;
      } else if (hasPermission !== PermissionStatus.granted) {
        const accepted: boolean = await this.cameraPermissionService.requestCameraAccess();
        if (!accepted) {
          this.errorType.emit(RecognitionErrors.Permissions);
          return;
        }
      }
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.availableCameras = devices.filter(device => device.kind === 'videoinput');
      if (this.availableCameras.length == 1) {
        this.onCameraSelected(this.availableCameras[0].deviceId);
      }
      this.camerasChecked = true;
    } catch (error) {
      console.error(error);
    }
  }

  onCameraSelected(cameraId:string){
    this.selectedCameraId = cameraId;
    this.cameraSelection.emit(this.selectedCameraId);
  }

  close(){
    this.closeCameraSelection.emit(false);
  }
}
